import { render, staticRenderFns } from "./StrategyIndexPage.vue?vue&type=template&id=67e49601&scoped=true"
import script from "./StrategyIndexPage.vue?vue&type=script&lang=js"
export * from "./StrategyIndexPage.vue?vue&type=script&lang=js"
import style0 from "./StrategyIndexPage.vue?vue&type=style&index=0&id=67e49601&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e49601",
  null
  
)

export default component.exports